import React, { useState } from 'react';

const NOMBRES_ODU = {
  0: "Opira", 1: "Okana", 2: "Ejioko", 3: "Ogunda", 4: "Irosun",
  5: "Oche", 6: "Obara", 7: "Odi", 8: "Ejiogbe", 9: "Osa",
  10: "Ofun", 11: "Ojuani", 12: "Eyila Chebora", 13: "Metanla",
  14: "Merinla", 15: "Marunla", 16: "Merindilogun"
};

export default function DiloggunSimulator() {
  const [paso, setPaso] = useState('INICIO'); // INICIO, LANZANDO_1, LISTO_1, LANZANDO_2, RESULTADO
  const [caracoles, setCaracoles] = useState(Array(16).fill(false));
  const [tiro1, setTiro1] = useState(null);
  const [tiro2, setTiro2] = useState(null);

  const realizarLanzamiento = () => {
    // Genera un array de 16 booleanos aleatorios (true = abierto, false = cerrado)
    const nuevoTiro = Array.from({ length: 16 }, () => Math.random() < 0.5);
    const abiertos = nuevoTiro.filter(Boolean).length;
    return { nuevoTiro, abiertos };
  };

  const simularTiro = (numeroTiro) => {
    setPaso(numeroTiro === 1 ? 'LANZANDO_1' : 'LANZANDO_2');
    
    // Efecto de animación rápido imitando el movimiento de los caracoles
    let botes = 0;
    const intervalo = setInterval(() => {
      setCaracoles(Array.from({ length: 16 }, () => Math.random() < 0.5));
      botes++;
      if (botes > 8) {
        clearInterval(intervalo);
        const { nuevoTiro, abiertos } = realizarLanzamiento();
        setCaracoles(nuevoTiro);
        
        if (numeroTiro === 1) {
          setTiro1(abiertos);
          setPaso('LISTO_1');
        } else {
          setTiro2(abiertos);
          setPaso('RESULTADO');
        }
      }
    }, 100);
  };

  const reiniciar = () => {
    setTiro1(null);
    setTiro2(null);
    setCaracoles(Array(16).fill(false));
    setPaso('INICIO');
  };

  const obtenerSignoFinal = () => {
    if (tiro1 === null || tiro2 === null) return "";
    if (tiro1 === tiro2 && tiro1 !== 0) {
      return `${NOMBRES_ODU[tiro1]} Meyi`;
    }
    return `${NOMBRES_ODU[tiro1]} ${NOMBRES_ODU[tiro2]}`;
  };

  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto', fontFamily: 'sans-serif', textAlign: 'center' }}>
      <h2>Simulador Litúrgico del Diloggun</h2>
      
      {/* Vista de los 16 caracoles */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', margin: '20px 0' }}>
        {caracoles.map((abierto, index) => (
          <div 
            key={index} 
            style={{
              padding: '20px',
              borderRadius: '50%',
              background: abierto ? '#fff7ed' : '#e2e8f0',
              border: abierto ? '2px solid #ea580c' : '2px solid #94a3b8',
              transition: 'all 0.1s ease',
              fontWeight: 'bold'
            }}
          >
            {abierto ? '🐚' : '•'}
          </div>
        ))}
      </div>

      {/* Control de flujo e información */}
      {paso === 'INICIO' && (
        <button onClick={() => simularTiro(1)} style={btnStyle}>Lanzar Signo Base (Tiro 1)</button>
      )}

      {paso === 'LANZANDO_1' && <p>Agitando los caracoles...</p>}

      {paso === 'LISTO_1' && (
        <div>
          <p><strong>Primer Tiro:</strong> {tiro1} caracoles abiertos ({NOMBRES_ODU[tiro1]})</p>
          <button onClick={() => simularTiro(2)} style={btnStyle}>Lanzar Acompañante (Tiro 2)</button>
        </div>
      )}

      {paso === 'LANZANDO_2' && <p>Agitando los caracoles...</p>}

      {paso === 'RESULTADO' && (
        <div style={{ background: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
          <h3>Resultado del Odú</h3>
          <p style={{ fontSize: '20px', color: '#ea580c' }}><strong>{obtenerSignoFinal()}</strong></p>
          <p>Combinación numérica: ({tiro1} - {tiro2})</p>
          <button onClick={reiniciar} style={{ ...btnStyle, background: '#64748b' }}>Nueva Consulta</button>
        </div>
      )}
    </div>
  );
}

const btnStyle = {
  background: '#ea580c',
  color: 'white',
  border: 'none',
  padding: '10px 20px',
  fontSize: '16px',
  borderRadius: '5px',
  cursor: 'pointer',
  marginTop: '10px'
};